export default function ColorAndPar(totaltopar, totaltopar_str) {
  let parColorClass;

  // console.log(totaltopar);
  if (totaltopar < 0) {
    parColorClass = "text-danger";
  }
  if (totaltopar > 0) {
    parColorClass = "text-primary";
  }

  let par = totaltopar_str;

  return { par, parColorClass };
}
